import { z } from "zod";

export const ZKonstruksjonerMotTerrengSchema = z.object({
  // 8
  isActive: z.boolean().default(false),
  tekst: z.string(),
  gulvPaGrunn: z.object({
    // 8.1
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
  ringmur: z.object({
    // 8.2
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
  veggerMotTerreng: z.object({
    // 8.2
    isActive: z.boolean().default(false),
    tekst: z.string(),
  }),
});

export type IKonstruksjonerMotTerrengSchema = z.infer<typeof ZKonstruksjonerMotTerrengSchema>;
